import { type ReactElement } from 'react';
import { SkeletonRows, useDelayedFlag } from '@vello/web-theme';
import { useT } from '../i18n/provider';

/**
 * A panel or a block of text that is still loading: skeleton lines after the theme's 300 ms delay (a fast load never
 * flashes one), a spoken "Loading" status, and `aria-busy` on the region. It replaces the centred grey "Loading…" line
 * the screens used to hand-roll (audit admin #5 / #11). Tables use `ListTable`'s own `loading` instead.
 */
export function LoadingBlock({ lines = 3 }: { lines?: number }): ReactElement {
  const { t } = useT();
  const shown = useDelayedFlag(true);
  return (
    <div className="vello-loading" role="status" aria-busy="true" data-pending={shown ? 'false' : 'true'}>
      <span className="vello-sr-only">{t('ui.loading')}</span>
      <SkeletonRows count={lines} />
    </div>
  );
}
